import api from '../../../../api/clients/api';
import { PaginatedResponse } from '../../../../types/responses/paginated-response';

import { Alert } from '@/features/access-control-events/api/types/alert';

class AlertsApi {
  async fetchAlerts(page: number, perPage: number): Promise<PaginatedResponse<Alert>> {
    const { data } = await api.get('/visitor-security-alerts', {
      params: {
        page,
        perPage,
      },
    });

    return data;
  }
}

export const alertsApi = new AlertsApi();
